import { Stack, Autocomplete, TextField, Typography, Button, CircularProgress } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";

import './style.css';
import { useForm } from "../../hooks/useForm";
import { ChooseEstimate } from "./components/ChooseEstimate";
import { Message } from "../../components/Message";
import { messagesAddCertification } from "../../helpers/certificationMessage";
import useFetch from "../../hooks/useFetch";
import { urlGetNameClients } from "../../helpers";

export const AddCertification = () => {

    const navigate = useNavigate();
    const { data: dataClient, loading } = useFetch(urlGetNameClients, 'GET');

    const [hiddenComponent, setHiddenComponent] = useState(false);
    const [body, setbody] = useState({});
    const [ids, setIds] = useState({});
    const [saveOk, setSaveOk] = useState(false);
    const [product, setProducts] = useState([]);
    const [rents, setRents] = useState([]);
    const [formValues, handleInputChange] = useForm({
        client: '', certificationDate: ''
    });
    const { client } = formValues;
    
    const handleClick = (e) => {
        e.preventDefault()
        const { target } = e;
        const { firstDate, lastDate } = target;
        setbody({
            'rents' : JSON.stringify(rents),
            "firstDate": firstDate?.value,
            "lastDate": lastDate?.value,
            "product": JSON.stringify(product),
            "clientId": ids.idClient,
            "workId": ids.workId,
            "certificationDate": ids.certificationDate,
            "estimateId": ids.estimateId
        })
        setSaveOk(!saveOk)
    }

    if (loading) {
        return (
            <Stack width='100%' alignItems='center' justifyContent='center' mt='2rem'>
                <CircularProgress />
            </Stack>
        );
    }

    return (
        <Stack flexDirection='row' width='100%' justifyContent='center' >
                <Stack width='95%' alignItems='center' component='form' className="form_certification" onSubmit={handleClick} >
                    <Typography textAlign='center' variant="h5" pt={3} color="primary">Añadir Certificación</Typography>
                    <Stack flexDirection='row' width='100%' flexWrap='wrap' justifyContent='space-around' gap={2} pb={5}>
                        <Autocomplete
                            disabled={hiddenComponent}
                            disablePortal
                            options={dataClient?.map((c) => c.name) || ['Cargando productos']}
                            sx={{ width: 300 }}
                            size='small'
                            value={client || null}
                            onChange={(event, newValue) => {
                                handleInputChange({ target: { name: 'client', value: newValue || '' } });
                            }}
                            renderInput={(params) => <TextField {...params} label="Cliente" required />}
                        />
                        {(dataClient?.map((c) => c.name).includes(client)) && <ChooseEstimate setRents={setRents} setIds={setIds} setProducts={setProducts} dataClient={dataClient} client={client} hiddenComponent={hiddenComponent} setHiddenComponent={setHiddenComponent} />}
                    </Stack>
                    {hiddenComponent &&
                        <Stack flexDirection='row' flexWrap='wrap' justifyContent='flex-end' width='90%' gap={5} mb='1rem'>
                            <Button sx={{width:'100px'}} variant="outlined" size='small' onClick={() => navigate('/certification')}>Cancelar</Button>
                            <Button sx={{width:'100px'}} variant="contained" size='small' type='submit'>Añadir</Button>
                        </Stack>}
                </Stack>
            {saveOk && <Message messages={messagesAddCertification} body={body} method='POST' />}
        </Stack>
    )
}